module.exports = __webpack_public_path__ + "media/images/page/reason_illust01-72cfae81e0f579a186c29a522894fd9a.png";